import { Language } from './base';

const pdash = () => import('../translations/pdash/fa-IR.json');
const webActivities = () => import('../translations/web-activities/fa-IR.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/fa-IR.json');

export default new Language({
    code: 'fa-IR',
    locale: 'fa',
    localName: 'فارسی',
    englishName: 'Farsi',
    territory: 'IR',
    timezones: ['Asia/Tehran'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
